import React from 'react';
import {TableRowStyle} from './TableRowStyle';

export interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    /** If provided, will apply extra header styles. */
    header?: boolean;
}

/** @component */
export const TableRowBase: React.FunctionComponent<TableRowProps> = props => <tr {...props} />;
